/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__switch_to_jove__model__Status;

(function (jove__app__switch_to_jove__model__Status) {
  jove__app__switch_to_jove__model__Status["CREATED"] = "created";
  jove__app__switch_to_jove__model__Status["FAILED"] = "failed";
  jove__app__switch_to_jove__model__Status["FINISHED"] = "finished";
})(jove__app__switch_to_jove__model__Status || (jove__app__switch_to_jove__model__Status = {}));